import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";
import "./valeCooler.css";

function CoolerImpoView({ awb, operacion, onBack }) {
  // Temperatura requerida mostrada en UI (por defecto "N/A")
  const [temperaturaRequerida, setTemperaturaRequerida] = useState("N/A");

  // Campos controlados del formulario
  const [movimiento, setMovimiento] = useState(""); // select Movimiento
  const [temperatura, setTemperatura] = useState(""); // input temperatura (número)
  const [searchIngreso, setSearchIngreso] = useState(""); // texto buscador
  const [selectedIngreso, setSelectedIngreso] = useState(""); // valor seleccionado para "Realiza Ingreso"
  const [showIngresoList, setShowIngresoList] = useState(false);
  const [observaciones, setObservaciones] = useState("");
  const [locacion, setLocacion] = useState("");

  // Controlar visibilidad de tabla piezas
  const [showTablaPiezas, setShowTablaPiezas] = useState(false);

  // Histórico local (array de filas)
  const [historicoRows, setHistoricoRows] = useState([]);

  // Referencia para detectar click fuera del buscador
  const ingresoRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ingresoRef.current && !ingresoRef.current.contains(event.target)) {
        setShowIngresoList(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Opciones del buscador (ejemplo)
  const ingresoOptions = [
    "204005, ADRIAN MORENO VALADEZ",
    "184118, AGUSTIN MATÍAS RAMOS",
    "201478, ALEJANDRO VELAZQUEZ GONZALEZ",
    "12232, Alicia Paredes Perez",
    "408017, ANGEL RODRIGO LOPEZ VAZQUEZ",
    "215517, CARLOS GARCIA TORRES",
    "44923, CRISTHIAN ANTONIO CHAVEZ LUNA",
  ];

  const filteredOptions = ingresoOptions.filter((opt) =>
    opt.toLowerCase().includes(searchIngreso.toLowerCase())
  );

  // Maneja la edición de Temperatura requerida vía SweetAlert (igual que antes)
  const temperatureAlert = () => {
    Swal.fire({
      title: "",
      html: `
        <div class="container-fluid text-left">
          <div class="row">
            <div class="col-md-6 d-flex justify-content-center align-items-center mt-3">
              <h3 class="fw-bold text-center m-0" style="font-size: 15px;">Temperatura requerida</h3>
            </div>

            <div class="col-md-6 mt-3">
              <select id="temperatura_select" class="form-select" style="border-radius:8px;">
                <option value="" disabled selected>Selecciona temperatura</option>
                <option>N/A</option>
                <option value="FRO: -7°C a -2°C">FRO: -7°C a -2°C</option>
                <option value="COL: +2°C a +8°C">COL: +2°C a +8°C</option>
                <option value="ERT: +2°C a +25°C">ERT: +2°C a +25°C</option>
                <option value="CRT: +15°C a +25°C">CRT: +15°C a +25°C</option>
              </select>
            </div>
          </div>
        </div>
      `,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Guardar",
      customClass: {
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        popup: "alert-bg",
      },
      preConfirm: () => {
        const value = document.getElementById("temperatura_select").value;
        if (!value) {
          Swal.showValidationMessage("Debes seleccionar una opción");
        }
        return value;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setTemperaturaRequerida(result.value);
        // Si la temperatura cambia, permitir que aparezca "Ingreso" en el select Movimiento:
        // (esto lo manejamos dinámicamente al construir las opciones del select)

        Swal.fire({
          icon: "success",
          title: "Éxito",
          text: `Nueva temperatura actualizada con éxito.`,
          confirmButtonText: "OK",
          customClass: { confirmButton: "btn-ok" },
        });
      }
    });
  };

  // Resetea los campos editables (se usan cuando el usuario intenta guardar)
  const resetEditableFields = () => {
    setMovimiento("");
    setTemperatura("");
    setSelectedIngreso("");
    setSearchIngreso("");
    setShowIngresoList(false);
    setObservaciones("");
    setShowTablaPiezas(false);
  };

  // Handler del botón Guardar (no guarda nada en backend)
  const handleGuardar = (e) => {
    e.preventDefault();

    const anyFilled =
      movimiento &&
      movimiento.trim() !== "" &&
      temperatura !== "" &&
      temperatura !== null &&
      selectedIngreso &&
      selectedIngreso.trim() !== "";

    if (!anyFilled) {
      Swal.fire({
        icon: "info",
        title: "Campos incompletos",
        text: "Debes llenar todos los campos para continuar.",
        confirmButtonText: "OK",
        customClass: { confirmButton: "btn-ok" },
      });
      return;
    }

    // 👉 CASO 1: Transferencia o Resguardo -> SE GUARDA EN HISTÓRICO
    if (movimiento === "Transferencia" || movimiento === "Resguardo") {
      const now = new Date();
      const fecha = now.toISOString().split("T")[0];
      const hora = now.toTimeString().split(" ")[0].slice(0, 5);

      const newRow = {
        movimiento,
        temperatura: temperatura,
        piezas: "-",
        peso: "-",
        fecha,
        hora,
        observaciones: observaciones || "-",
        check: false,
      };

      setHistoricoRows((prev) => [newRow, ...prev]);

      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: "Registro agregado al histórico correctamente.",
        confirmButtonText: "OK",
        customClass: { confirmButton: "btn-ok" },
      }).then(() => {
        resetEditableFields();
      });

      return;
    }

    // 👉 CASO 2: Ingreso / Reingreso -> NO GUARDA, SOLO MUESTRA ALERTA
    if (movimiento === "Ingreso" || movimiento === "Reingreso") {
      setShowTablaPiezas(true);

      Swal.fire({
        icon: "warning",
        title: "Proceso detenido",
        text: "Para realizar este proceso, es necesario el 'Inicio Despaletizado'",
        confirmButtonText: "OK",
        customClass: { confirmButton: "btn-ok" },
      }).then(() => {
        resetEditableFields();
        setShowTablaPiezas(true); // se mantiene visible
      });

      return;
    }
  };

  // Construcción dinámica de opciones de movimiento:
  // Por defecto: Anden/Confronta, Transferencia, Resguardo, Reingreso
  // Si temperaturaRequerida !== "N/A" -> agregamos "Ingreso"
  const movimientoOptionsBase = [
    "Anden/Confronta",
    "Transferencia",
    "Resguardo",
    "Reingreso",
  ];
  const movimientoOptions =
    temperaturaRequerida !== "N/A"
      ? [
          ...movimientoOptionsBase.slice(0, 3),
          "Ingreso",
          movimientoOptionsBase[3],
        ]
      : movimientoOptionsBase;

  // Mostrar/Ocultar Locación:
  // - Por defecto oculto (cuando movimiento === ""), se muestra si movimiento !== "" y movimiento !== "Anden/Confronta"
  const showLocacion = movimiento !== "" && movimiento !== "Anden/Confronta";

  // Mostrar div rojo: cuando movimiento es Ingreso o Reingreso
  const showDivRojo = movimiento === "Ingreso" || movimiento === "Reingreso";

  return (
    <>
      <Helmet>
        <title>Horus | Vale Cooler</title>
      </Helmet>

      <ScrollToTop />

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 mb-3 text-right">
            <div className="col-12 d-flex justify-content-end">
              <button className="btnn">Tiempos impo</button>
            </div>
          </div>

          {/* --- Datos generales --- */}
          <div className="col-md-3">
            <strong className="bold">Master: </strong>139-39993671
          </div>
          <div className="col-md-3">
            <strong className="bold">Piezas: </strong>7
          </div>
          <div className="col-md-3">
            <strong className="bold">Peso: </strong>1639
          </div>
          <div className="col-md-3">
            <strong className="bold">Volumen: </strong>5.56
          </div>

          <div className="col-md-3 mt-4">
            <strong className="bold">Origen: </strong>LHR
          </div>
          <div className="col-md-3 mt-4">
            <strong className="bold">Destino: </strong>MEX
          </div>
          <div className="col-md-3 mt-4">
            <strong className="bold">Tipo de mercancía: </strong>Consolidado
          </div>

          {/* --- Temperatura requerida editada dinámicamente --- */}
          <div className="col-md-3 mt-4">
            <strong className="bold">Temperatura requerida: </strong>
            <span>{temperaturaRequerida}</span>

            <div className="mt-2">
              <button className="btn-pink-secondary" onClick={temperatureAlert}>
                Editar
              </button>
            </div>
          </div>
        </div>

        {/* --- FORMULARIO --- */}
        <form onSubmit={handleGuardar}>
          <div className="row mt-4">
            <div className="col-md-3">
              <label className="micro-title font-semibold mb-2">
                Movimiento
              </label>
              <select
                className="form-select"
                value={movimiento}
                onChange={(e) => {
                  setMovimiento(e.target.value);
                  // Si selecciona Ingreso/Reingreso vamos a mostrar tabla piezas
                  if (
                    e.target.value === "Ingreso" ||
                    e.target.value === "Reingreso"
                  ) {
                    setShowTablaPiezas(true);
                  } else {
                    setShowTablaPiezas(false);
                  }
                }}
              >
                <option value="">Selecciona una opción</option>
                {movimientoOptions.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label className="micro-title font-semibold mb-2">
                Temperatura
              </label>
              <input
                type="number"
                className="form-control"
                value={temperatura}
                onChange={(e) => setTemperatura(e.target.value)}
                placeholder=""
              />
            </div>

            {/* --- SELECT CON BUSCADOR --- */}
            <div
              className="col-md-3"
              ref={ingresoRef}
              style={{ position: "relative" }}
            >
              <label className="micro-title font-semibold mb-2">
                Realiza Ingreso
              </label>

              {/* Input + ícono ▼ */}
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Selecciona una opción…"
                  value={selectedIngreso || searchIngreso}
                  onChange={(e) => {
                    setSelectedIngreso("");
                    setSearchIngreso(e.target.value);
                    setShowIngresoList(true);
                  }}
                  onFocus={() => setShowIngresoList(true)}
                  style={{ paddingRight: "30px" }}
                  aria-haspopup="listbox"
                  aria-expanded={showIngresoList}
                />

                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    fontSize: "12px",
                    color: "#555",
                    cursor: "pointer", // icono muestra manita
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Lista de opciones */}
              {showIngresoList && (
                <div
                  className="mt-1"
                  role="listbox"
                  style={{
                    maxHeight: "150px",
                    overflowY: "auto",
                    background: "white",
                    position: "absolute",
                    zIndex: 20,
                    width: "92%",
                    borderRadius: "6px",
                    boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                    border: "1px solid #ddd",
                  }}
                >
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((opt) => (
                      <div
                        key={opt}
                        role="option"
                        onClick={() => {
                          setSelectedIngreso(opt);
                          setSearchIngreso("");
                          setShowIngresoList(false);
                        }}
                        style={{
                          padding: "10px 12px",
                          cursor: "pointer", // <-- manita al acercar el cursor
                          borderBottom: "1px solid #f1f1f1",
                        }}
                        tabIndex={0}
                      >
                        {opt}
                      </div>
                    ))
                  ) : (
                    <div style={{ padding: "10px 12px", color: "#777" }}>
                      No hay resultados
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="col-md-3">
              <label className="micro-title font-semibold mb-2">
                Observaciones
              </label>
              <textarea
                className="form-control"
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
              />
            </div>

            {/* --- CAMPOS NO EDITABLES --- */}
            <div className="col-md-3 mt-3">
              <label className="micro-title font-semibold mb-2">
                Responsable
              </label>
              <input
                type="text"
                readOnly
                className="form-control"
                style={{ background: "#E3E3E3" }}
                value="Ezequiel Bernal"
              />
            </div>

            <div className="col-md-3 mt-3">
              <label className="micro-title font-semibold mb-2">Fecha</label>
              <input
                type="date"
                readOnly
                className="form-control"
                style={{ background: "#E3E3E3" }}
                value="2025-11-20"
              />
            </div>

            <div className="col-md-3 mt-3">
              <label className="micro-title font-semibold mb-2">Hora</label>
              <input
                type="time"
                readOnly
                className="form-control"
                style={{ background: "#E3E3E3" }}
                value="10:30"
              />
            </div>

            {/* LOCACIÓN (por defecto oculto) */}
            {showLocacion && (
              <div className="col-md-3 mt-3">
                <label className="micro-title font-semibold mb-2">
                  Locación
                </label>
                <select
                  className="form-select"
                  value={locacion}
                  onChange={(e) => setLocacion(e.target.value)}
                >
                  <option value="">Selecciona una opción</option>
                  <option value="Talma">Talma</option>
                  <option value="TME">TME</option>
                  <option value="AAACESA">AAACESA</option>
                  <option value="WEC">WEC</option>
                  <option value="IMM">IMM</option>
                </select>
              </div>
            )}
          </div>

          {/* --- DIV ROJO (aparece solo para Ingreso/Reingreso) */}
          {showDivRojo && (
            <div className="row mt-3">
              <div className="col-md-12">
                <div
                  style={{
                    border: "2px solid red",
                    padding: "12px",
                    borderRadius: "6px",
                    color: "#a00",
                    background: "#fff5f5",
                  }}
                >
                  Atención: movimiento requiere revisión (Ingreso/Reingreso)
                </div>
              </div>
            </div>
          )}

          {/* --- TABLA PIEZAS (se muestra cuando movimiento es Ingreso/Reingreso) */}
          {showTablaPiezas && (
            <div className="row mt-4 justify-content-center">
              <div className="col-md-8">
                <table className="table text-center fondo-head">
                  <thead>
                    <tr>
                      <th>Piezas</th>
                      <th>Peso</th>
                      <th>Locación</th>
                      <th>Pallet</th>
                      <th>Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Como no tienes inputs de piezas/peso todavía, dejo una fila de ejemplo vacía */}
                    <tr>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="col-12 d-flex justify-content-end mt-3">
            <button type="submit" className="btnn">
              Guardar
            </button>
          </div>
        </form>

        {/* ---TABLA HISTÓRICO --- (SE MUESTRA SIEMPRE) */}
        <div className="row mt-4 justify-content-center">
          <div className="col-12">
            <h4 className="text-center mb-4">Histórico</h4>
          </div>

          <div className="col-md-8">
            <table className="table text-center fondo-head">
              <thead>
                <tr>
                  <th>Movimiento</th>
                  <th>Temperatura</th>
                  <th>Piezas</th>
                  <th>Peso</th>
                  <th>Fecha</th>
                  <th>Hora</th>
                  <th>Observaciones</th>
                  <th>Check</th>
                </tr>
              </thead>
              <tbody>
                {historicoRows.length === 0 ? (
                  <tr>
                    <td colSpan={8}>No hay registros</td>
                  </tr>
                ) : (
                  historicoRows.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.movimiento}</td>
                      <td>{row.temperatura}</td>
                      <td>{row.piezas}</td>
                      <td>{row.peso}</td>
                      <td>{row.fecha}</td>
                      <td>{row.hora}</td>
                      <td>{row.observaciones}</td>
                      <td>
                        <input type="checkbox" checked={row.check} readOnly />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="col-md-8 d-flex justify-content-end">
            <button className="btnn">Imprimir</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CoolerImpoView;
